import { cn } from "../../../../utils/utils";

/**
 * Responsive grid 1 → 4 cột cho các card lời mời.
 * Dùng chung cho Sent / Received / GroupInvitations tabs.
 */
const InvitationGrid = ({ children, className }) => {
  return (
    <div
      className={cn(
        "grid gap-3 p-4",
        "grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default InvitationGrid;
